import React from "react";
import { ChevronRight } from "lucide-react";
import { Icon } from "./icons.jsx";
import { NotificationButton } from "./notifications.jsx";
import { useIgualdad } from "./igualdad-store.jsx";
import { metaDeRuta, navigate } from "./router.jsx";
import { useStore as useSvpt } from "./svpt/store.jsx";

/* ============================================================
   Talention — Topbar unico de la aplicacion
   Migas + buscador + contexto activo + notificaciones.
   ============================================================ */

/* Contexto activo: empresa → ejercicio. Una sola barra para toda la app. */
function ContextoActivo() {
  const { session, setPoliticaById } = useIgualdad();

  return (
    <div className="ctx" title="Contexto de trabajo">
      {session.cliente ? (
        <>
          <span className="ctx-item ctx-empresa">{session.cliente.nombre}</span>
          <button className="ctx-cambiar" onClick={() => navigate("/empresas")}>Cambiar</button>
        </>
      ) : (
        <button className="ctx-cambiar" onClick={() => navigate("/empresas")}>Elegir empresa</button>
      )}
      {/* El registro del ejercicio se resuelve solo al entrar en la empresa, así
          que no se pide elegirlo: solo se dice con cuál se está trabajando.
          En cuanto hay más de uno vuelve a hacer falta poder cambiarlo. */}
      {session.politica ? (
        <>
          <ChevronRight size={12} />
          {session.politicas.length > 1 ? (
            <select
              className="ctx-select"
              value={session.politica.id}
              onChange={(e) => setPoliticaById(e.target.value)}
              aria-label="Ejercicio activo"
            >
              {session.politicas.map((x) => (
                <option key={x.id} value={x.id}>Ejercicio {x.ejercicio}</option>
              ))}
            </select>
          ) : (
            <span className="ctx-item">Ejercicio {session.politica.ejercicio}</span>
          )}
        </>
      ) : null}
    </div>
  );
}

function AppTopbar({ route }) {
  // El topbar vive dentro de SvptProvider (App.jsx); fuera de él, useSvpt da null.
  const svpt = useSvpt();
  const meta = metaDeRuta(route, svpt?.state?.metodo);

  return (
    <header className="topbar">
      <div className="crumbs">
        {meta.crumbs.map((c, i) => (
          <span key={i} className="crumb">
            {i > 0 && <ChevronRight size={13} />}
            <span className={i === meta.crumbs.length - 1 ? "is-last" : ""}>{c}</span>
          </span>
        ))}
      </div>
      <div className="topbar-search">
        <Icon name="search" size={15} />
        <input placeholder="Buscar puestos, departamentos…" />
        <span className="kbd">⌘K</span>
      </div>
      <ContextoActivo />
      <NotificationButton />
    </header>
  );
}

export { AppTopbar, ContextoActivo };
